<!-- <button mat-button [routerLink]="'/buy'">
    Accueil 
</button>

<button mat-button [routerLink]="'/buy/search'">
    Recherche 
</button>

<button mat-button [routerLink]="'/buy/details'">
    Details 
</button> -->

<router-outlet></router-outlet>